import { AnalyticsDispatcher } from '../../internal/AnalyticsDispatcher';
import { withExtras as higherOrder } from '../../extenders';
function withExtras(extras) {
    return higherOrder(extras)(this);
}
AnalyticsDispatcher.prototype.withExtras = withExtras;
//# sourceMappingURL=withExtras.js.map